import ReminderOptions from './ReminderOptions';

export default ReminderOptions;
